<template>
  <Loading class="center" v-if="loading" type="spinner" color="#2faeff" vertical
    >加载中...</Loading
  >
  <div
    v-else
    :class="[
      'content-leval',
      {
         'wrap-normal': themeType === THEME_TYPE_COMMON,
         'wrap': themeType === THEME_TYPE_PARTY,
         'pk-wrap': (isPk || themeType === THEME_TYPE_NONE),
      },
    ]"
    :style="styleObj?.backImg"
  >
    <!-- 自定义的背景 -->
    <!-- <div class="diy-bg"></div> -->
    <template v-if="themeType !== THEME_TYPE_NONE">
      <div class="rule">
        <Button @click="handleRuleClick" class="btn">规则</Button>
      </div>
      <div class="main-title">{{ $store.getters.getQuesInfo?.title }}</div>
    </template>
    <PkInfo
      v-if="isPk"
      :rightCount="rightCount"
      :robotCount="robotCount"
      :robotFail="robotFail"
      :userFail="userFail"
      :quesData="quesData"
    />
    <div class="content-wrap">
      <!-- pk自己的倒计时 -->
      <div v-if="(isPk || themeType === THEME_TYPE_NONE)" class="pk-time-wrap">
        <img src="@/assets/img/pk/time.png" alt="" />
        {{ countdown }}s
      </div>
      <div v-else class="circle-wrap">
        <Circle
          v-model:current-rate="currentRate"
          :rate="rate"
          :stroke-width="70"
          color="#FFDE3A"
          size="50px"
          :text="countdown.toString()"
        >
        </Circle>
      </div>
      <div class="content">
        <transition
          enter-class="animate__animated animate__fadeInRight animate__faster"
          leave-class="animate__animated animate__fadeOutLeft animate__faster"
          enter-active-class="animate__animated animate__fadeInRight animate__faster"
          leave-active-class="animate__animated animate__fadeOutLeft animate__faster"
          mode="out-in"
        >
          <Choice
            ref="choiceRef"
            :key="quesData.questionKey"
            :index="currentIndex"
            :isPk="isPk"
            @submit="handleSelected"
            :data="quesData"
            :showFail="showFail"
            :isNormal="isNormal"
            :showSuccess="showSuccess"
          />
        </transition>
        <div v-if="!isPk" class="schedule">
          {{ schedule }}
        </div>
      </div>
    </div>
  </div>
  <!-- 规则弹窗 -->
  <Overlay :show="showRule" @click="showRule = false">
    <RuleDialog @close="showRule = false" />
  </Overlay>
  <template v-if="!isPk">
    <!-- 成功/失败提示弹窗 -->
    <Overlay
      :show="
        ($store.getters.getQuesSetting?.competitionType !== 2 ||
          $store.getters.getQuesSetting?.answerStatus === 1) &&
        showSuccess
      "
    >
      <div class="result-tips-wrap">
        <div class="result-tips">
          <img src="@/assets/img/competition/success.gif" alt="" />
          <p>回答正确!</p>
        </div>
      </div>
    </Overlay>
    <Overlay
      :show="
        ($store.getters.getQuesSetting?.competitionType !== 2 ||
          $store.getters.getQuesSetting?.answerStatus === 1) &&
        showFail
      "
    >
      <div class="result-tips-wrap">
        <div class="result-tips">
          <img
            v-if="!showActFail"
            src="@/assets/img/competition/fail.gif"
            alt=""
          />
          <img v-else src="@/assets/img/competition/fail.png" alt="" />
          <p>回答错误!</p>
          <Button
            v-if="$store.getters.getQuesSetting.competitionType !== 2"
            @click="handleJump2Home($store.getters.getType)"
            class="fish-btn"
            :class="{ normal: isNormal }"
            >结束挑战</Button
          >
        </div>
      </div>
    </Overlay>
  </template>
</template>

<script setup>
import { Button, Circle, Overlay, Dialog, Loading, Popup } from 'vant'
import { ref, computed, watch, onUnmounted, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import RuleDialog from './components/ruleDialog'
import PkInfo from './components/pkInfo'
import Choice from './components/choice'
import { submit } from '@/api/competition'
import qs from 'qs'
import { useCommonStyleEffect } from '@/effects/styleConfigEffect'
import { useCommonQuesListEffect } from '@/effects/quesListEffect'
import { THEME_TYPE_NONE, THEME_TYPE_COMMON, THEME_TYPE_PARTY } from '@/constants'
import { getQueryString } from '@/utils/tools'

const store = useStore()
const route = useRoute()
const router = useRouter()

// 题目相关数据
const quesData = ref(null)
const quesList = ref([])
// 页面加载
const loading = ref(true)

// 主题样式
const themeType = computed(() => store.getters.getQuesSetting?.answerType)

// 初始化题目
async function initQuesData() {

  const { getQuesData } = useCommonQuesListEffect()

  try {
    await getQuesData(quesList, quesData)
    loading.value = false
  } catch (error) {
    loading.value = false
  }
}

// 是否是pk
const isPk = computed(() => {
  return store.getters?.getQuesSetting?.isLevel === 3
})

// 显示规则弹窗
const showRule = ref(false)
const handleRuleClick = () => {
  showRule.value = true
}

// 提示相关
const showFail = ref(false)
const showSuccess = ref(false)
// 失败的图一直闪，这个是控制显示静态失败图
const showActFail = ref(false)

// 答对题数
const rightCount = ref(0)
// 机器人答对题数
const robotCount = ref(0)

// 机器人档位出现概率列表
const winningRateList = computed(() => {
  let list = []
  if (store.getters.getQuesSetting?.pkInfo) {
    list = JSON.parse(store.getters.getQuesSetting.pkInfo)
  }

  list.forEach((item) => {
    if (item.probability) {
      item.probability = item.probability / 100
    }
  })

  return list
})

// 计算机器人胜率，读取配置来获得档位机器人
// 分为6档机器人，从winningRate中 根据每个档位的出现的概率来随机出机器人
function getRandomElementWithProbability(array) {
  // 计算总概率
  const totalProbability = array.reduce(
    (acc, element) => acc + element.probability,
    0
  )

  // 生成一个随机数，用于确定选中哪个元素
  const randomValue = Math.random() * totalProbability

  // 遍历数组，累积概率，直到找到随机值所在的区间
  let cumulativeProbability = 0
  for (const element of array) {
    cumulativeProbability += element.probability
    if (randomValue <= cumulativeProbability) {
      return element
    }
  }

  // 如果没有找到匹配的元素（理论上不会发生）
  return null
}

// 机器人获胜概率
const robotWinRate = ref(
  getRandomElementWithProbability(winningRateList.value)?.rate
)

// 用户答题总时长
const userTime = ref(0)
// 机器人答题总时长
const robotTime = ref(0)
// 开始时间
const startTime = ref(new Date())

// 用户答错
const userFail = ref(false)

// 机器人是否答题
const robotAnswer = ref(false)
// 机器人是否答错
const robotFail = ref(false)

const robotAnswerTimeOut = ref()
// 随机机器人答题，时间在大于0.5s
const handleRandomRobotAnswer = () => {
  // 随机时间在1.5s到 timeLimt / 2
  const timeLimt = store.getters.getQuesSetting.timeLimit
      ? store.getters.getQuesSetting.timeLimit
      : 30
  const randomTime = Math.floor(Math.random() * (timeLimt * 1000 / 2 - 1500 + 1)) + 1500;

  robotAnswerTimeOut.value = setTimeout(() => {
    setRobotRight()
  }, randomTime)
}

// 开始先随机一次
onMounted(() => {
  initQuesData()
  handleRandomRobotAnswer()
})

// 根据概率设置机器人答对题数
function setRobotRight() {
  // 机器人已经答题，不再 重复答题。（假如用户答完题，机器人还没答，会强制让机器人答题。避免重复。）
  if (robotAnswer.value) {
    return
  }
  robotAnswer.value = true

  const randomValue = Math.random()

  // 如果随机数小于等于指定概率，给变量加1
  if (randomValue <= robotWinRate.value) {
    robotCount.value++
  } else {
    robotFail.value = true
  }

  // 设置机器人答题时长
  robotTime.value += new Date() - startTime.value
}

// 设置基础样式
const { isNormal, styleObj } = useCommonStyleEffect()

// 倒计时相关
const currentIndex = ref(0)
const currentRate = ref(0)
// 倒计时圆环进度
const rate = ref(0)
const countdown = ref(store.getters.getQuesSetting?.timeLimit || 30)

// 时间倒计时，圆环进度增加
const countInterval = ref(null)
onMounted(() => {
  countInterval.value = setInterval(() => {
  const timeLimit = store.getters.getQuesSetting?.timeLimit || 30
  const speed = 100 / timeLimit

  if (countdown.value > 0) {
      rate.value += speed
      countdown.value--
    }

  }, 1000)
})

// 进度
const schedule = computed(() => {
  return `${currentIndex.value + 1}/${quesList.value.length}`
})

// 重置 倒计时
const handleResetCountdown = () => {
  rate.value = 0
  if (isPk.value) {
   setTimeout(() => {

     // pk模式的机器人答题状态重置
      robotAnswer.value = false
      robotFail.value = false
      // pk模式重置用户答错状态
      userFail.value = false
      handleRandomRobotAnswer()
    countdown.value = store.getters.getQuesSetting.timeLimit
      ? store.getters.getQuesSetting.timeLimit
      : 30

      userEnd.value = false

   }, 1000)
    return
  }

  countdown.value = store.getters.getQuesSetting.timeLimit
    ? store.getters.getQuesSetting.timeLimit
    : 30

  // 重置答题开始时间
  store.commit('setStartTime', {
    time: new Date(),
  })
}

onUnmounted(() => {
  clearInterval(countInterval.value)
})

// 用户本轮是否结束
const userEnd = ref(false)

// 点击提交
const submitFlag = ref(false)
const answerGroupKey = ref('')
// 处理每次选择
const handleSelected = async (answers) => {

  const isSetting = getQueryString('isSetting')
  // 后台设置样式的时候不提交
  if (isSetting) {
    return
  }

  // 防止重复提交
  if (submitFlag.value) {
    return
  }

  const personAnswerList = store.getters.getPersonAnswers || []
  submitFlag.value = true
  const data = {
    questionActiveKey: route.query.questionActiveKey,
    answerJson: JSON.stringify(currentIndex.value === 0 ?  [...personAnswerList, ...answers] : answers),
    longTime: new Date() - store.getters.getStartTime,
    token: store.getters.getToken,
    isComplete: currentIndex.value + 1 === quesList.value.length ? 1 : 0,
    isStart: currentIndex.value + 1 === 1 ? 1 : 0,
    unitId: route.query.unitId,
    orgId: store.getters.getOrgId,
    isPreview: route.query.isPreview,
    activeId: route.query.activeId,
  }

  // 只要点了 就是结束了
  userEnd.value = true

  const res = await submit(qs.stringify(data))

  // 随机一个1s到6s的时间
  let randomTime = Math.floor(Math.random() * 5000) + 1000
  // 剩余时间小于6s的话，随机一个1s到剩余时间的时间
  if (countdown.value < 6) {
    randomTime = Math.floor(
      Math.random() * (countdown.value * 1000 - 1000) + 1000
    )
  }
  // let randomTime = Math.floor(Math.random() * (countdown.value * 1000 - 1000) + 1000)

  if (res.ret === '200') {
    // 答对
    if (res.data) {
      userFail.value = false
      showSuccess.value = true
      answerGroupKey.value = res.dataMap?.answerGroupKey
      rightCount.value++

      // 机器人已经答完题，不再答题，同时让延迟时间为0
      if (robotAnswer.value) {
        randomTime = 0
      } else {
        // 没回答的时候，清除机器人答题，免得重复
        clearTimeout(robotAnswerTimeOut.value)

        setTimeout(() => {
          setRobotRight()
        }, randomTime)
      }

      setTimeout(
        () => {
          currentIndex.value++
          const type = store.getters.getType
          let path =
            type === 'gq' ? '/competition/result-new' : '/competition/result'

          const query = {
            ...route.query,
            answerGroupKey: res.dataMap.answerGroupKey,
            resultType: 1,
            isSuccess: 1,
          }

          if (isPk.value) {
            path = '/competition/pk-result'
            query.rightCount = rightCount.value
            query.robotCount = robotCount.value
          }
          console.log('res', res)
          // 设置了规定答题数，答完题目后跳转 || 闯关结束
          if (res.dataMap.endFlag || currentIndex.value === quesList.value.length) {
            router.replace({
              path: path,
              query: query,
            })
            return
          }
          quesData.value = quesList.value[currentIndex.value]
          showSuccess.value = false
          // 初始化倒计时
          handleResetCountdown()
        },
        isPk.value ? 900 + randomTime : 400
      )
    } else {
      // 机器人已经答完题，不再答题，同时让延迟时间为0
      if (robotAnswer.value) {
        randomTime = 0
      } else {
        clearTimeout(robotAnswerTimeOut.value)

        setTimeout(() => {
          setRobotRight()
        }, randomTime)
      }

      // 判断提交类型，是答错继续答题 还是答错终止
      if (store.getters.getQuesSetting.competitionType === 2 || isPk.value) {
        showFail.value = true
        userFail.value = true
        showActFail.value = true
        answerGroupKey.value = res.dataMap.answerGroupKey
        const query = {
          ...route.query,
          answerGroupKey: res.dataMap.answerGroupKey,
          resultType: 1,
        }

        let path = '/competition/result'

        if (isPk.value) {
          query.rightCount = rightCount.value
          query.robotCount = robotCount.value
          path = '/competition/pk-result'
        }

        setTimeout(
          () => {
            currentIndex.value++
            // 闯关结束
            if (currentIndex.value === quesList.value.length) {
              router.replace({
                path,
                query,
              })
              return
            }

            quesData.value = quesList.value[currentIndex.value]
            showFail.value = false
            // 初始化倒计时
            handleResetCountdown()
          },
          isPk.value ? 1000 + randomTime : 600
        )
      } else {
        showFail.value = true
        answerGroupKey.value = res.dataMap.answerGroupKey
        setTimeout(() => {
          showActFail.value = true
        }, 600)
      }
    }
  } else {
    Dialog({ message: res.comment }).then(() => {
      router.push({
        path: '/',
        query: route.query,
      })
    })
  }
  submitFlag.value = false
}

// 答题ref
const choiceRef = ref(null)
// 监听倒计时
watch(countdown, (n) => {
  // 倒计时结束
  if (n <= 0) {
    countdown.value = 0
    // 点了提交的到点不用自动提交
    if (showFail.value || showSuccess.value) {
      return
    }

    // pk提交了 需要调用一下限制
    if (isPk.value && userEnd.value) {
      return
    }

    if (choiceRef.value) {
      choiceRef.value?.handleSetSelect(true)
    }

    // 倒计时结束 自动提交一个假的答案，后台不支持传空
     handleSelected([
      {
        questionKey: quesData.value.questionKey,
        answers: [
          {
            questionKey: quesData.value.questionKey,
            optionKey: 'no_answer',
          },
        ],
      },
    ])
  }
})

// 失败结束跳转
const handleJump2Home = (type) => {
  const path = type === 'gq' ? '/competition/result-new' : '/competition/result'
  router.replace({
    path: path,
    query: {
      ...route.query,
      resultType: 1,
      answerGroupKey: answerGroupKey.value,
      isSuccess: 0,
    },
  })
}
</script>

<style lang="scss" scoped>
.content-leval {
  position: relative;
  min-height: 100vh;
}

.wrap {
  position: relative;
  width: 100%;
  min-height: 1624px;
  background: no-repeat top/100%
    url('../../assets/img/competition/home-bg-party.png');
  background-color: rgb(228, 65, 62);
}

.wrap-normal {
  width: 100%;
  min-height: 1624px;
  background: no-repeat top/100%
    url('../../assets/img/competition/home-bg-normal.png');
  background-color: rgb(195, 238, 255);

  .main-title {
    background: no-repeat top/100%
      url('../../assets/img/competition/title-wrap-normal.png');
  }
}

.rule {
  text-align: right;

  .btn {
    margin-top: 50px;
    margin-right: 40px;
    min-width: 118px;
    height: 48px;
    background: #f7fbfe;
    box-shadow: 0px 0px 10px 0px rgba(47, 117, 182, 0.1);
    opacity: 0.6;
    border-radius: 23px;
    font-size: 28px;
    color: #eb5046;
  }
}

.main-title {
  margin: 0 auto;
  margin-top: 62px;
  text-align: center;
  width: 521px;
  height: 97px;
  line-height: 90px;
  font-size: 36px;
  color: #ffffff;
  background: no-repeat top/100%
    url('../../assets/img/competition/title-wrap.png');
}


.content-wrap {
  position: relative;
  margin: 0 auto;
  margin-top: 80px;
  padding-bottom: 100px;
  width: 724px;
  min-height: 866px;
  text-align: center;
  background: no-repeat top/100%
    url('../../assets/img/competition/competition-wrap.png');

  .circle-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    margin: 0 auto;
    top: -60px;
    left: 0;
    right: 0;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0px 1px 10px 0px rgba(128, 126, 124, 0.26);
    z-index: 1;
    // .circle-text {
    //   width: 100%;
    //   height: 100%;
    //   text-align: center;
    //   line-height: 50px;
    //   font-size: 44px !important;
    //   color: #fd7777 !important;
    // }
  }

  .pk-time-wrap {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 12px 22px;
    min-width: 150px;
    font-size: 36px;
    font-weight: bold;
    color: #333333;
    background-color: #f3f6ff;
    border-radius: 20px;

    img {
      margin-right: 10px;
      width: 54px;
      height: 66px;
    }
  }

  .content {
    position: relative;
    margin: 0 auto;
    width: 670px;
    min-height: 823px;
    background-color: #fff;
    border-radius: 10px;
    border: 1px solid #eee;

    .schedule {
      position: absolute;
      text-align: center;
      left: 0;
      right: 0;
      bottom: 42px;
      color: #f2877e;
      font-size: 32px;
      font-weight: bold;
    }
  }
}

.result-tips-wrap {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.result-tips {
  img {
    display: block;
    margin: 0 auto;
    width: 350px;
    height: 350px;
  }

  p {
    margin: 0;
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    color: #ffffff;
  }
}

.fish-btn {
  display: block;
  margin: 0 auto;
  margin-top: 320px;
  width: 433px;
  height: 111px;
  background: linear-gradient(0deg, #ff9c2e, #ffde3a);
  box-shadow: 0px 1px 10px 0px rgba(254, 167, 74, 0.57);
  border-radius: 56px;
  border: none;
  font-size: 42px;
  color: #ffffff;
}

.normal {
  background: linear-gradient(265deg, #2b91ff, #1fbcff);
}

@media (max-height: 800px) {
  .wrap {
    .rule {
      .btn {
        margin-top: 60px;
      }
    }
  }
}
</style>
<!-- pk样式 -->
<style lang="scss" scoped>


.pk-wrap {
  box-sizing: border-box;
  padding-top: 72px;
  min-height: 100vh;
  background-image: none;
  background-color: #ffffff;

  .content-wrap {
  margin-top: 32px;
  background: none;

  .content {
    border: none;
    background: none;

    ::v-deep {
      .choice-wrap {
        width: 640px;

        .title {
          font-size: 32px;
          color: #333333;
          font-weight: bold;
          line-height: 44px;
        }

        .list-wrap {
          .list-item {
            margin-bottom: 30px;
            width: 100%;
            min-height: 108px;
            border-radius: 20px;
            font-size: 40px;
            color: #333333;
            justify-content: center;
            text-align: center;
            border: 2px solid #e0e0e0;
            background-color: #ffffff;
          }

          .right {
            color: #0677f5;
            font-weight: bold;
            background: none;
            background-color: rgba(230, 241, 254, 1);
            border: 2px solid #0677f5;
            box-shadow: none;
          }

          .wrong {
            color: #ff0000;
            background: none;
            box-shadow: none;
            background-color: #ffefef;
            border: 2px solid #ff0000;
          }
        }
      }
    }
  }
}

  .content {
    .title {
      margin-top: 54px;
    }
  }
}
</style>
<style>
.van-circle__text {
  font-size: 22px !important;
  color: #fd7777 !important;
}

.company {
  position: relative;
  top: -40px;
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  color: #26a3ff;
  opacity: 0.7;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.animate__faster {
  animation-duration: 0.8s !important;
}
</style>
